import clsx from "clsx"
import { FC } from "react"
import style from "./RoundAvatar.module.css"

type RoundAvatarSize = "s" | "m" | "l" | "xxl"

const sizeToClass = Object.freeze({
  s: "w-6 h-6",
  m: "w-7 h-7",
  l: "w-9 h-9",
  xxl: "w-28 h-28",
})

type RoundAvatarProps = {
  imgSrc: string
  imgAlt: string
  size: RoundAvatarSize
  displayShadow?: boolean
  displayBackground?: boolean
  cropImage?: boolean
}

export const RoundAvatar: FC<RoundAvatarProps> = ({
  imgSrc,
  imgAlt,
  size,
  displayShadow,
  displayBackground = true,
  cropImage,
}) => {
  return (
    <div
      className={clsx(
        style["round-avatar"],
        sizeToClass[size],
        displayShadow && style["round-avatar-shadow"],
        displayBackground && style["round-avatar-background"]
      )}
    >
      <img
        className={clsx("w-full h-full", cropImage && style["round-avatar-image"])}
        src={imgSrc}
        alt={imgAlt}
      />
    </div>
  )
}
